import { ICollectionPoint, ICollectionPointOperator, IReportType, ISortCode, ISorter, IStore } from './DataModelInterface';

export const storeValue = (key: string, value: string | null) => {
  if (value !== null) {
    sessionStorage.setItem(key, value);
  } else {
    clearValue(key);
  }
}

export const storeObject = (key: string, value: object) => {
  const valueStr = JSON.stringify(value);
  storeValue(key, valueStr);
}

export const fetchValue = (key: string) => {
  return sessionStorage.getItem(key);
}

export const fetchObject = (key: string) => {
  const value = fetchValue(key);
  return value ? JSON.parse(value) : null;
}

export const clearValue = (key: string) => {
  sessionStorage.removeItem(key);
}

const getStore = () => {
  const store: IStore = fetchObject('store') || {};
  return store;
}

export const getSorters = () => {
  const store = getStore();
  return store ? store.sorters : [];
}

export const setSorters = (sorters: ISorter[]) => {
  const store = getStore();
  store.sorters = sorters;
  storeObject('store', store);
}

export const getSortCodes = () => {
  const store = getStore();
  return store ? store.sortCodes : [];
}

export const setSortCodes = (sortCodes: ISortCode[]) => {
  const store = getStore();
  store.sortCodes = sortCodes;
  storeObject('store', store);
}

export const getCollectionpointOperators = () => {
  const store = getStore();
  return store ? store.collectionpointOperators : [];
}

export const setCollectionpointOperators = (operators: ICollectionPointOperator[]) => {
  const store = getStore();
  store.collectionpointOperators = operators;
  storeObject('store', store);
}

export const getCollectionpoints = () => {
  const store = getStore();
  return store ? store.collectionpoints : [];
}

export const setCollectionpoints = (points: ICollectionPoint[]) => {
  const store = getStore();
  store.collectionpoints = points;
  storeObject('store', store);
}

export const getBackendVersion = () => {
  const store = getStore();
  return store ? store.backendversion : "";
}

export const setBackendVersion = (version: string) => {
  const store = getStore();
  store.backendversion = version;
  storeObject('store', store);
}

export const getReportTypes = () => {
  const store = getStore();
  return store ? store.reportTypes : [];
}

export const setReportTypes = (reportTypes: IReportType[]) => {
  const store = getStore();
  store.reportTypes = reportTypes;
  storeObject('store', store);
}
